import * as React from "react";
import { Button, Form } from "antd";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { documentsTableStore } from "../Stores/DocumentsTableStore";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { notificationSuccess } from "utils/libHelpers/AntdNotification";
import { PathDirectorySelect } from "Components/Form/PathDirectorySelect";

export interface MoveFolderFormProps extends ModalComponentProps {
  folderId: number;
  stayInCurrentFolder?: boolean;
  /* used to preselect folder when open modal */
  initialFolderId?: number;
  onSubmitSuccess?: (folderId: number) => void;
}

export const MoveFolderForm = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<MoveFolderFormProps & WithTranslation, { loading: boolean }> {
      readonly state = { loading: false };

      handleFinish = async (values) => {
        const { t, stayInCurrentFolder } = this.props;
        try {
          this.setState({ loading: true });
          await documentsTableStore.moveFolder(this.props.folderId, values.folderId, stayInCurrentFolder);
          this.props.hideModal();
          notificationSuccess(t("Success"), t("Moved directory."));
          if (typeof this.props.onSubmitSuccess === "function") {
            this.props.onSubmitSuccess(values.folderId);
          }
        } catch (error) {
          throw error;
        } finally {
          this.setState({ loading: false });
        }
      };

      render() {
        const { loading } = this.state;
        const { t, initialFolderId } = this.props;

        return (
          <Form onFinish={this.handleFinish} initialValues={{ folderId: initialFolderId }}>
            <Form.Item
              name="folderId"
              label={t("Select destination path")}
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: t("This field is required") }]}
            >
              <PathDirectorySelect />
            </Form.Item>
            <div className="text-right">
              <Button htmlType="submit" type="primary" loading={loading}>
                {t("Save")}
              </Button>
            </div>
          </Form>
        );
      }
    }
  )
);
